/*
 * SelectItemText.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface ISelectItemTextProps {
	className?: string;
	primary?: React.ReactNode;
	secondary?: React.ReactNode;
}

export const SelectItemText: React.FC<ISelectItemTextProps> = ({
	children,
	className,
	primary,
	secondary
}) => {
	const baseClass = BEM("edt-select-item-text");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("primary").toClassName()}>{primary || children}</div>
			{secondary && <div className={baseClass.element("secondary").toClassName()}>{secondary}</div>}
		</div>
	);
};
